// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__238hM","Logos":"Footer_Logos__s3HF3","DonorLogo":"Footer_DonorLogo__28CN7","Links":"Footer_Links__mnUs6","Text":"Footer_Text__1xkHN"};